const HTTP_METHOD = Object.freeze({
  GET: 'GET',
  POST: 'POST'
});

const CONTENT_TYPE = Object.freeze({
  JSON: 'application/json'
});

class RequestError extends Error {
  constructor(message, { status, data }) {
    super(message);
    this.name = 'RequestError';
    this.status = status;
    this.response = { data, status };
  }
}

function parseResponseBody(response) {
  if (response.status === 204) {
    return Promise.resolve(null);
  }

  return response.clone().json().catch(() => response.text());
}

async function request(config) {
  const {
    url, method = HTTP_METHOD.GET, headers = {}, data
  } = config;
  const options = { method, headers: { Accept: 'application/json, text/plain, */*', ...headers }};

  if (data !== undefined) {
    if (data instanceof FormData) {
      delete options.headers['Content-Type'];
      options.body = data;
    } else {
      options.headers['Content-Type'] = CONTENT_TYPE.JSON;
      options.body = JSON.stringify(data);
    }
  }

  const response = await fetch(url, options);
  const responseData = await parseResponseBody(response);

  if (!response.ok) {
    throw new RequestError(
      `${method} ${url} failed with status ${response.status}`,
      { status: response.status, data: responseData }
    );
  }

  return { data: responseData, status: response.status };
}

request.get = (url) => request({ url, method: HTTP_METHOD.GET });
request.post = (url, data) => request({ url, data, method: HTTP_METHOD.POST });

export default request;
